import { GameActions, IGameLoadData } from 'State/Game/GameActions';
import Game from 'Game';
import { handleIAP } from 'System/Preload/HandleIAP';
import { runAsyncPreloadTasks } from './RunAsyncPreloadTasks';


export async function startGame(gameLoadedState: IGameLoadData) {
    GameActions.setLoadedData(gameLoadedState);

    Game.player.data.start();

    await handleIAP();

    GameActions.gameLoaded();

    // Asynchronous tasks - do not await.
    runAsyncPreloadTasks();
}
